import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { FilterMetadata, SortMeta } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { Orden } from '../../domain/orden.domain';

@Injectable({
  providedIn: 'root'
})
export class OrdenService {
  protected http = inject(HttpClient);
  protected apiUrl: string = `${environment.URL_API}/ordenes`;

  findAll(
    paginate: boolean,
    page: number,
    size: number,
    termino: string,
    multiSortMeta: SortMeta[] | undefined,
    filtersMetadata: any,
    accept: string = ''
  ): Observable<any> {
    let httpOptions: any = {};

    if (accept !== undefined && accept !== null && accept !== '' && accept === 'json') {
      httpOptions = {
        headers: new HttpHeaders({ Accept: 'application/json' })
      };
    }

    let url = `${this.apiUrl}?size=${size}&page=${page}`;

    if (paginate !== undefined && !paginate) {
      url = `${this.apiUrl}?pagination=false`;
    }

    if (multiSortMeta !== undefined && multiSortMeta !== null && multiSortMeta.length > 0) {
      multiSortMeta.forEach((element: SortMeta) => {
        let direction = 'asc';
        if (element.order === -1) {
          direction = 'desc';
        }
        url += `&_order[${element.field}]=${direction}`;
      });
    }

    if (termino !== undefined && termino !== null && termino.trim() !== '') {
      url += `&q=${encodeURIComponent(termino.trim())}`;
    }

    if (filtersMetadata !== undefined && filtersMetadata !== null) {
      Object.keys(filtersMetadata).forEach((property) => {
        const filter: any = filtersMetadata[property];
        if (filter !== undefined && filter instanceof Array) {
          filter.forEach((element: FilterMetadata) => {
            if (element.value !== null && element.value !== undefined && element.value !== '') {
              url += `&${property}=${encodeURIComponent(element.value)}`;
            }
          });
        }
        if (filter !== undefined && filter instanceof Object && !(filter instanceof Array)) {
          if (filter.value !== null && filter.value !== undefined && filter.value !== '') {
            url += `&${property}=${encodeURIComponent(filter.value)}`;
          }
        }
      });
    }

    return this.http.get(url, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        console.error('Error en OrdenService:', error);
        return throwError(() => error);
      })
    );
  }

  getById(id: number | string): Observable<Orden> {
    return this.http.get<Orden>(`${this.apiUrl}/${id}`);
  }

  create(entity: Orden): Observable<Orden> {
    return this.http.post<Orden>(this.apiUrl, entity);
  }

  update(id: number | string, entity: Partial<Orden>): Observable<Orden> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json'
    });
    return this.http.patch<Orden>(`${this.apiUrl}/${id}`, entity, { headers });
  }

  delete(id: number | string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  exportJson(id: number | string): Observable<any> {
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });
    return this.http.get(`${this.apiUrl}/${id}/export.json`, { headers });
  }
}
